/* eslint-disable import/prefer-default-export */
/* eslint-disable react/prop-types */
import React from 'react';
import { PropTypes } from 'prop-types';
import { useLocalizedFromContext } from 'data/Localization';

export const GradientCrop24 = ({ title, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="83.013"
    height="88.454"
    viewBox="0 0 83.013 88.454"
    {...props}
  >
    <title>{useLocalizedFromContext(title)}</title>
    <defs>
      <clipPath id="clip-path24">
        <path
          id="Path_188"
          dataname="Path 188"
          d="M917.275,47.323a1.5,1.5,0,0,0-1.858-.348c-.528.286-10.522,5.777-16.472,13.669a137.489,137.489,0,0,1,10.664-31.553,1.5,1.5,0,0,0-1.844-2.1c-5.279,1.935-10.847,6.464-14.614,9.951.586-1.66.963-2.634.984-2.687a1.5,1.5,0,0,0-1.907-1.958c-7.258,2.636-12.523,7.723-16.3,13.175V24.7c3.078,5.726,6.761,6.848,6.861,6.875a5.681,5.681,0,0,0,1.858.31,5.741,5.741,0,0,0,5.161-8.263c-.041-.083-.1-.152-.144-.233.087-.037.176-.068.262-.11a5.74,5.74,0,0,0-.59-10.561c-.146-.059-3.171-1.2-8.225.6,3.409-4.228,3.3-7.488,3.3-7.582A154.459,154.459,0,0,1,870.185,0a5.73,5.73,0,0,0-5.74,5.667c-.007.157-.112,3.425,3.295,7.653-5.049-1.8-8.061-.662-8.148-.627a5.741,5.741,0,0,0-.659,10.587c.082.04.168.07.251.106a5.748,5.748,0,0,0,5.034,8.508A5.468,5.468,0,0,0,866,31.6c.166-.048,3.848-1.17,6.926-6.887V42.688a18.457,18.457,0,0,0-7.954-7.875,1.5,1.5,0,0,0-2.058,1.752c.856,3.258.99,8.185.923,12.157-4.971-10.016-12.531-19.214-24.028-23.513a1.5,1.5,0,0,0-1.433,2.6c.1.078,7.859,6.4,13.75,31.356-6-7.092-14.8-11.922-15.292-12.19a1.5,1.5,0,0,0-1.9,2.237c8.759,11.3,9.654,37.524,9.663,37.788a1.5,1.5,0,0,0,1.5,1.454h60.06a1.5,1.5,0,0,0,1.5-1.454c.009-.264.9-26.492,9.663-37.788A1.5,1.5,0,0,0,917.275,47.323Zm-12.129-15.78c-3.688,8.345-11.758,29.347-12.079,53.911H884.8c-1.365-14.367,3.047-31.848,6.266-42.224C892.319,41.891,898.657,35.268,905.146,31.543ZM887.24,27.035a2.756,2.756,0,0,1-3.529,1.687c-.031-.01-3.127-1.066-5.674-6.5-.232-.494-.47-1-.7-1.484l8.2,2.813a2.74,2.74,0,0,1,1.7,3.482Zm1.049-11.5a2.741,2.741,0,0,1,.315,5.054,2.712,2.712,0,0,1-2.093.13l-8.2-2.813c.481-.242.979-.493,1.465-.741C885.117,14.436,888.212,15.5,888.289,15.531ZM878.665,3a2.757,2.757,0,0,1,2.742,2.792c0,.032.006,3.3-4.3,7.475-.393.379-.792.768-1.177,1.145V5.741A2.744,2.744,0,0,1,878.665,3Zm-8.48,0a2.744,2.744,0,0,1,2.74,2.741v8.671c-.386-.377-.784-.765-1.177-1.145-4.311-4.172-4.307-7.443-4.3-7.526A2.745,2.745,0,0,1,870.185,3ZM858.863,19.012a2.758,2.758,0,0,1,1.75-3.5,5.82,5.82,0,0,1,1.756-.214,14.91,14.91,0,0,1,6.712,1.862c.486.248.984.5,1.466.741l-8.2,2.813a2.74,2.74,0,0,1-3.482-1.7Zm6.234,9.726a2.742,2.742,0,0,1-3.482-1.7,2.745,2.745,0,0,1,1.7-3.482l8.2-2.813c-.231.486-.47.99-.7,1.484C868.271,27.656,865.176,28.712,865.1,28.738Zm1.363,10.617A17.038,17.038,0,0,1,872.342,51.5a61.921,61.921,0,0,0-3.742,9.222c-.6-1.911-1.271-3.85-2.027-5.79A92.66,92.66,0,0,0,866.46,39.355Zm-25.8,13.6c4.7,3.324,11.176,8.809,13.307,15,.955,5.177,1.815,10.991,2.533,17.5H847.53C847.265,80.5,846.014,64.26,840.655,52.958Zm18.866,32.5c-3.455-31.7-10.277-47.323-14.83-54.525,21.129,13.049,24.937,46.862,25.535,54.525Zm13.723,0a113.068,113.068,0,0,0-3.057-19.067c.69-3.147,5.443-22.388,19.927-29.9-2.948,8.361-9.984,30.669-8.335,48.965Zm31.476,0h-8.643a122.9,122.9,0,0,1,1.358-16.471,1.492,1.492,0,0,0,.8-.886c2.078-6.236,8.617-11.781,13.359-15.134C906.236,64.265,904.985,80.5,904.72,85.454Z"
          fill="none"
        />
      </clipPath>
    </defs>
    <g id="Group_72" dataname="Group 72" transform="translate(-834.618)">
      <g id="Group_71" dataname="Group 71" clipPath="url(#clip-path24)">
        <g id="Group_70" dataname="Group 70">
          <path
            id="Path_185"
            dataname="Path 185"
            d="M918.25,88.462V53.44L834.068,73.159v15.3Z"
            fill="#5f9501"
          />
          <path
            id="Path_186"
            dataname="Path 186"
            d="M834.068,34.492V73.159L918.25,53.44V14.774Z"
            fill="#79b61d"
          />
          <path
            id="Path_187"
            dataname="Path 187"
            d="M834.068.006V34.492L918.25,14.774V.006Z"
            fill="#c8d200"
          />
        </g>
      </g>
    </g>
  </svg>
);

GradientCrop24.defaultProps = {
  title: 'clover_grass_min60',
};

GradientCrop24.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
};
